import React from "react";
import useDeedToast from "hook/useDeedToast";
import "./styles.css";
import { FileUploadRounded, RemoveCircleOutlineRounded } from "@mui/icons-material";

export const FileUploader = ({ selectedFiles, setSelectedFiles, formik }) => {
  const { deedToast } = useDeedToast();
  const allowedFileTypes = [
    "image/png",
    "image/jpeg",
    "image/jpg",
    "image/webp",
    "application/pdf",
    "text/plain",
    "application/plain",
    "text/csv",
  ];

  const MAX_FILE_SIZE_MB = 10;

  const validateFileType = (file) => allowedFileTypes.includes(file.type);

  const validateFileSize = (file) =>
    file.size <= MAX_FILE_SIZE_MB * 1024 * 1024;

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (!file) return;

    if (!validateFileType(file)) {
      deedToast("Invalid file type. Please upload a valid file.", "danger");
      return;
    }

    if (!validateFileSize(file)) {
      deedToast(`File size exceeds ${MAX_FILE_SIZE_MB}MB.`, "danger");
      return;
    }

    const updatedFiles = [...selectedFiles, file];
    setSelectedFiles(updatedFiles);
    formik.setFieldValue("attachments", updatedFiles); // Update Formik state
  };

  const handleFileRemove = (index) => {
    const updatedFiles = selectedFiles.filter((_, i) => i !== index);
    setSelectedFiles(updatedFiles);
    formik.setFieldValue("attachments", updatedFiles); // Update Formik state
  };

  return (
    <div className="file-uploader">
      <h5>Attachments</h5>

      <div className="file-container-wrapper">
        <div className="file-input-container">
          <label htmlFor="file-upload" className="custom-file-button">
            <span className="custom-file-button-label">
              <FileUploadRounded /> Choose File
            </span>
          </label>
          <input
            id="file-upload"
            type="file"
            onChange={handleFileChange}
            accept={allowedFileTypes.join(",")}
            style={{ display: "none" }}
          />
        </div>

        <div className="file-list">
          {selectedFiles.map((file, index) => (
            <div key={index} className="file-item">
              <span className="file-name">{file.name}</span>
              <button
                type="button"
                onClick={() => handleFileRemove(index)}
                className="remove-button"
              >
                <span className="remove-button-label">
                  <RemoveCircleOutlineRounded sx={{ marginRight: "5px", width: "20px" }} />
                  Remove
                </span>
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
